export const environmentNames: any = {
  test: "Test",
  prod: "Production",
} as const;

export const descriptionTooltip = "Please include package name, relevance of milestone timing, data type and format including round of transfer, file total if applicable, and any other information significant to the delivery e.g. 1234-321_Prod_005_20251231-1159 is the third of four IA2 raw clinical data transfers and includes 26 SAS files as part of the agreed post-DSMB delivery schedule";
